<script setup lang="ts">
import BotFooter from '@/components/BotFooter.vue'
import TopNav from '@/components/TopNav.vue'
import { whySellWithUs } from '@/data/whySellWithUs'
import { useLangTools } from '@/lang'
import { useRouter } from 'vue-router'

const router = useRouter()

const { $tdb } = useLangTools(router)
</script>

<template>
	<div>
		<div class="act_oval" />
		<TopNav />
		<div class="page-wrap relative">
			<div class="act_w1170 side-title">
				<div class="act_frame">
					<h1 class="playfair act_txt60 act_no-marg balance">
						{{ $tdb(whySellWithUs[0], 'title') }}
					</h1>
				</div>
				<div class="white-box">
					<div v-for="item in whySellWithUs[0].points" :key="item._id" class="act_gap-2 icon-txt act_pb-3">
						<img width="30" height="60" class="act_pt-05" :src="item.icon.imageURL" :alt="$tdb(item, 'title')">
						<div>
							<h3 class="playfair act_txt30 act_no-marg act_pb-025">
								{{ $tdb(item, 'title') }}
							</h3>

							<div v-html="$tdb(item, 'body')" />
						</div>
					</div>
					<LocalLink to="/get-the-best-offer" class="act_btn mobile-full">
						{{ $t("cta.getStarted") }}
					</LocalLink>
				</div>
			</div>
			<img class="bot-img" src="@/assets/watch-bg.webp" alt="watch">
		</div>
		<BotFooter />
	</div>
</template>
